module.exports = __webpack_public_path__ + "img/3.30a85697.png";